<template>
  <Fieldset class="w-11" :toggleable="true" :collapsed="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="font-medium">Datos personales</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Cédula</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.identificationNumber }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Estado civil</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.maritalStatus }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nacionalidad</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.nationality
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Licencia de conducir</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.driverLicenseType }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Tipo de sangre</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.bloodType
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Género</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.gender
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de nacimiento</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            formattedBirthDate
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium"> N° Seguro Social</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.socialSecurityNumber }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12 mt-2">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Datos familiares</label>
          <i
            class="pi pi-eye text-blue-800 mt-2 cursor-pointer"
            style="font-size: 1.5rem"
            @click="seeRelatives = true"
          ></i>
        </div>
      </div>
      <Dialog
        v-model:visible="seeRelatives"
        modal
        header="Datos familiares"
        :style="{ width: '50vw' }"
        :breakpoints="{ '960px': '75vw', '641px': '100vw' }"
      >
        <DataTable
          style="width: 99%"
          scrollable
          scrollHeight="500px"
          :value="employee?.EmployeeRelatives"
          dataKey="code"
          tableStyle="min-width: 50rem"
          :globalFilterFields="['name']"
        >
          <template #empty> No se encontraron familiares. </template>
          <Column field="fullName" header="Nombre"></Column>
          <Column field="identificationNumber" header="ID"></Column>
          <Column field="address" header="Dirección"></Column>
          <Column field="phone" header="Telefono"></Column>
          <Column field="relationshipType" header="Parentesco"></Column>
          <Column field="isDisability" header="Discapacitado">
            <template #body="slotProps">
              <span v-if="slotProps.data.isDisability">Si</span>
              <span v-else>No</span>
            </template>
          </Column>
          <Column field="isDependent" header="Dependiente">
            <template #body="slotProps">
              <span v-if="slotProps.data.isDependent">Si</span>
              <span v-else>No</span>
            </template>
          </Column>
          <Column field="isStudent" header="Estudiante">
            <template #body="slotProps">
              <span v-if="slotProps.data.isStudent">Si</span>
              <span v-else>No</span>
            </template>
          </Column>
        </DataTable>
        <template #footer>
          <Button
            label="Cerrar"
            icon="pi pi-times"
            @click="seeRelatives = false"
          />
        </template>
      </Dialog>
    </div>
  </Fieldset>
</template>

<script setup lang="ts">
  import { ref, toRefs } from 'vue'
  import type { EmployeeDetail } from '@/modules/employees/models/EmployeeDetail'

  const props = defineProps<{
    class: string
    employee?: EmployeeDetail
    formattedBirthDate: string
  }>()

  const { employee, formattedBirthDate } = toRefs(props)
  const seeRelatives = ref(false)
</script>
